export default "__VITE_PUBLIC_ASSET__2516188d__"